import { render, staticRenderFns } from "./GroupPersonSetting.vue?vue&type=template&id=b2036040&scoped=true"
import script from "./GroupPersonSetting.vue?vue&type=script&lang=js"
export * from "./GroupPersonSetting.vue?vue&type=script&lang=js"
import style0 from "./GroupPersonSetting.vue?vue&type=style&index=0&id=b2036040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2036040",
  null
  
)

export default component.exports